import React from 'react'

export default function BorderRadiusTopLeft({ color = '#7246B1', style = {} }) {
    return (
        <svg
            className='icons-icon'
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M4 11V7C4 5.34315 5.34315 4 7 4H11' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
